import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DateTime } from 'luxon';
import * as fromSelectors from '../../store/parts-appointment/parts-appointment.selectors';
import { take } from 'rxjs/operators';
import * as fromActions from '../../store/parts-appointment/parts-appointment.actions';
import { PartsAppointmentState } from '../../store/parts-appointment/parts-appointment.reducer';
import { Store } from '@ngrx/store';
import { SearchCustomersState } from '../../store/search-customers/search-customers.reducer';
import { selectCurrentCustomer, selectPendingSearchInput } from '../../store/search-customers/search-customers.selectors';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { SubscriptionList } from '../../shared/models/asp.types';
import { ICustomer } from '@signal/asp-data-commons/lib/interfaces/appointment';
import { AppointmentBookingSource, AppointmentType } from '@signal/asp-data-commons/lib/enums/enum';
import { confirmConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SettingsState } from '../../store/settings/settings.reducer';
import { LoadSettings } from '../../store/settings/settings.actions';
import _ from 'lodash';
import { SelectLearningVehicleComponent } from '../shared/select-learning-vehicle/select-learning-vehicle.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { TradeInInfoComponent } from '../shared/trade-in-info/trade-in-info.component';
import { AvailabilityComponent } from '../../shared/components/availability/availability.component';
import { IGeneralSettingsAppointmentRequest } from '@signal/asp-data-commons';
import * as fromSettingsSelectors from "../../store/settings/settings.selectors";
import { CustomerType } from '../../shared/enums/customer-types.enum';
import { PendingSearchInput } from '../../store/search-customers/search-customers.actions';

@Component({
  selector: 'app-parts-appointment',
  templateUrl: './parts-appointment.component.html',
  styleUrls: ['./parts-appointment.component.scss']
})
export class PartsAppointmentComponent implements OnInit, OnDestroy, AfterViewInit {
  partsAppointmentForm: UntypedFormGroup;
  availability: UntypedFormControl;
  tradeInForm: UntypedFormControl;
  availabilityOptions$: any;
  availabilityOptionsLoading$: any;
  availability$: any;
  availabilityLoading$: any;
  transportOptions$: any;
  remoteZipcodes$: Observable<string[]>;
  yearList$: any;
  isUpdate: boolean = false;
  showMandatoryMsgCI: boolean = false;
  hasRemoteLocation: boolean = false;
  remoteValidZipcodes: { pmaZipCodes: string[], isRemote: boolean };
  isValidRemoteZip = false;
  transport: any;
  subscriptions: SubscriptionList = {};
  private contactEmailInfoForm: UntypedFormControl;
  customerDetails$: Observable<ICustomer>;
  private signedInUserDetails: ICustomer;
  isSubmitting = false;
  appointmentId: string;
  lastValue;
  editBool: boolean = false;
  oldValue: any;
  dateFormat: string = 'yyyy-MM-dd';
  apptType: string = AppointmentType.PARTS;
  valueChanged = true;
  isStoreUpdate = true;
  allowed = false;
  languageId = '';
  customerDataOnEdit;
  @ViewChild(SelectLearningVehicleComponent, { static: false }) selectVehicleComponent: SelectLearningVehicleComponent;
  @ViewChild(TradeInInfoComponent, { static: false }) tradeInInfoComponent: TradeInInfoComponent;
  @ViewChild(AvailabilityComponent, { static: false }) AvailabilityComponent: AvailabilityComponent;
  settings: IGeneralSettingsAppointmentRequest = {} as IGeneralSettingsAppointmentRequest;
  signalDeeplinkId = "";
  firstTimeDL = true;
  src = "";
  vehicleInfo = {};

  constructor(
    private readonly dialog: MatDialog,
    private readonly partsAppointmentStore: Store<PartsAppointmentState>,
    private bannerService: AspBannerService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly settingsState: Store<SettingsState>,
    private readonly translateService: TranslateService,
    private readonly cdr: ChangeDetectorRef) {
    this.settingsState.dispatch(new LoadSettings({ department: 'parts' }));
    this.initTechForm();

    /* logic to edit appointment */
    this.subscriptions.params = this.route.queryParams.subscribe(params => {
      if (params.src === "signal" && params.id) {
        this.signalDeeplinkId = params.id;
        this.src = params.src;
      } else {
        this.signalDeeplinkId = '';
        this.src = '';
        this.appointmentId = params.id;
        if (this.appointmentId) {
          this.editBool = true;
          this.partsAppointmentStore.dispatch(new fromActions.GetEditData
            ({ appointmentType: AppointmentType.PARTS, appointmentId: this.appointmentId }));
          /// check why the drvaFlag related data is missing in the customerDataOnEdit from store
          this.subscriptions.appointmentDetails = this.partsAppointmentStore.select(fromSelectors.appointmentDetails).subscribe((value) => {
            if (_.isEqual(this.lastValue, value)) {
              return;
            }
            this.lastValue = value;
            this.languageId = value?.availability?.languageId;
            if (!this.customerDataOnEdit?.firstName) {
              this.customerDataOnEdit = value.customer;
            }
            let updatedValue = { ...value }
            if (this.customerDataOnEdit.drvaFlag) {
              updatedValue = {
                ...value,
                customer: {
                  ...value.customer,
                  emailAddress: '',
                  phoneNumber: ' '
                }
              }
            }
            this.partsAppointmentForm.patchValue(updatedValue);
          })

        }
      }
    });
    /** this.salesAppointmentState.dispatch(new fromActions.LoadSeriesAndTrim()); */
    this.partsAppointmentStore.dispatch(new fromActions.LoadAvailabilityOptions({ appointmentType: AppointmentType.PARTS }));

  }
  canExit(): Observable<boolean> {
    let dialogRef;
    const result = new Subject<boolean>();
    dialogRef = this.dialog.open(ConfirmDialogComponent, confirmConfig);
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') { }
      else if (event.action === 'close') {
        result.next(true);
        result.complete();
      }
    });
    return result.asObservable();
  };

  // returns if the forms are edited
  formsNotEdited() {
    return this.valueChanged;
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  valuesChange(event) {
    this.valueChanged = event;
  }

  ngOnInit(): void {
    this.bannerService.update('');
    this.bannerService.show();
    this.setSignedInUserDetails();

    this.availabilityOptions$ = this.partsAppointmentStore.select(fromSelectors.getAvailabilityOptions);
    this.availabilityOptionsLoading$ = this.partsAppointmentStore.select(fromSelectors.getAvailabilityOptionsLoading);
    this.availabilityLoading$ = this.partsAppointmentStore.select(fromSelectors.getAvailabilityLoading);
    this.availability$ = this.partsAppointmentStore.select(fromSelectors.getAvailability);
    this.transportOptions$ = this.partsAppointmentStore.select(fromSelectors.getTransportOptions);
    this.remoteZipcodes$ = this.partsAppointmentStore.select(fromSelectors.getPMAZipCodes);
    this.yearList$ = this.partsAppointmentStore.select(fromSelectors.getYearList);
    this.subscriptions.generalSettings = this.settingsState.select(fromSettingsSelectors.selectSettings).subscribe(settings => {
      if (settings && Object.entries(settings).length) {
        this.settings.time = settings.time;
        this.settings.portal = settings.portal;
        this.settings.dealerInfo = settings.dealerInfo;
        this.settings.isAspCrmIntegrationEnabled = settings.isAspCrmIntegrationEnabled;
        this.settings.isAspDmsIntegrationEnabled = settings.isAspDmsIntegrationEnabled;
        this.settings.isConsumerPortalEnabled = settings.isConsumerPortalEnabled;
        this.settings.isServiceAccessible = settings.isServiceAccessible;
      }
    });
    if (!this.editBool) {
      this.subscriptions.appointmentDetails = this.partsAppointmentStore.select(fromSelectors.appointmentDetails).subscribe((value) => {

        if (_.isEqual(this.lastValue, value)) {
          this.isStoreUpdate = true;
          return;
        }
        this.lastValue = value;

        if (this.signalDeeplinkId) {
          this.vehicleInfo = this.lastValue?.vehicle;
        }
        this.partsAppointmentForm.patchValue(value);
      });
    }
    setTimeout(() => {
      if (this.firstTimeDL && this.signalDeeplinkId) {
        this.firstTimeDL = false;
        this.partsAppointmentStore.dispatch(
          new fromActions.LoadSalesAppointmentFromSignalDeepLink({ signalDeeplinkId: this.signalDeeplinkId }));
      }
    }, 0);
  }

  initTechForm() {

    this.partsAppointmentForm = this.formBuilder.group({
      transportationTypeCode: ['DEALER'],
      remoteZipCode: [''],
      availability: this.availability,
      customer: this.contactEmailInfoForm,
      tradeIn: this.tradeInForm
    });
    this.subscriptions.formChanges = this.partsAppointmentForm.valueChanges.subscribe((data) => {
      this.onValueChange();
    })
  }

  onValueChange() {
    const value = _.cloneDeep(this.partsAppointmentForm?.value);
    this.isStoreUpdate = false;
    if (this.checkOldValue(value)) {
      this.isStoreUpdate = true;
      return;
    }
    if ((value.availability?.advisorId && this.oldValue.availability?.advisorId !== value.availability.advisorId)
      || (value.transportationTypeCode && this.oldValue?.transportationTypeCode && this.oldValue?.transportationTypeCode !== value.transportationTypeCode)) {
      if (value.availability.appointmentStartDate) {
        const date = DateTime.fromFormat(value.availability.appointmentStartDate, this.dateFormat)
          .startOf('month')
          .toFormat(this.dateFormat);
        this.partsAppointmentStore.dispatch(new fromActions.LoadAvailability(
          {
            selectDateAndSlot: true, date, advisorId: value.availability.advisorId, transport: value.transportationTypeCode, vin: '',
            appointmentType: AppointmentType.PARTS, appointmentId: this.appointmentId ? this.appointmentId : ''
          }));
      }
      else {
        const advisor = value.availability.advisorId ? value.availability.advisorId : '-1';
        this.partsAppointmentStore.dispatch(new fromActions.LoadAvailability(
          {
            selectDateAndSlot: false, date: '', advisorId: advisor, transport: value.transportationTypeCode, vin: '',
            appointmentType: AppointmentType.PARTS, appointmentId: this.appointmentId ? this.appointmentId : ''
          }));
      }
    }
    this.oldValue = value;

    this.toCheckAllowOnEditMode();

    if (value?.customer?.emailAddress) {
      value.customer.emailAddress = value.customer.emailAddress.trim();
    }

    if (this.allowed && !this.isStoreUpdate) {
      this.isStoreUpdate = true;
      this.lastValue = { ...this.lastValue, ...value };
      this.partsAppointmentStore.dispatch(new fromActions.UpdateSalesFormData({ value, appointmentType: AppointmentType.PARTS }));
    }
  }
  isCIformValid(event) {
    this.showMandatoryMsgCI = event;
  }

  toCheckAllowOnEditMode() {
    /**in editmode when form value will be loaded perfectly then it will be allowed to update the state. It will look for this change onetime, next time onward form will detect changes accordingly. */
    if (this.editBool && !this.allowed) {
      if (this.isValidForm()) {
        this.allowed = true;
      }
    }
    /** normal flow, this form will be allowed to do the changes anytime. */
    if (!this.editBool) {
      this.allowed = true;
    }
  }

  checkOldValue(newValue) {
    return _.isEqual(this.oldValue, newValue);
  }

  setSignedInUserDetails() {
    this.customerDetails$ = this.searchCustomersState.select(selectCurrentCustomer);
    this.subscriptions.customerSub = this.customerDetails$
      .subscribe(customer => {
        const pendingSearchInput = customer ? null : this.getPendingSearchInputSnapshot();
        this.signedInUserDetails = {
          firstName: customer?.firstName || pendingSearchInput?.firstName || '',
          lastName: customer?.lastName || pendingSearchInput?.lastName || '',
          emailAddress: !customer?.drvaFlag
            ? (customer?.emailAddress || this.getPendingEmail(pendingSearchInput))
            : '',
          phoneNumber: !customer?.drvaFlag
            ? (customer?.phoneNumber || this.getPendingPhone(pendingSearchInput))
            : ' ',
          customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
          businessName: customer?.businessName || '',
          drvaFlag: customer?.drvaFlag || false
        };
        this.partsAppointmentForm.patchValue({ customer: this.signedInUserDetails });
        this.partsAppointmentStore.dispatch(new fromActions.LoadCustomerDetails({ signedInUserDetails: this.signedInUserDetails }));
      });

  }

  private getPendingSearchInputSnapshot(): PendingSearchInput | null {
    let pendingSearchInput: PendingSearchInput | null = null;
    this.searchCustomersState.select(selectPendingSearchInput).pipe(take(1)).subscribe(value => {
      pendingSearchInput = value;
    });
    return pendingSearchInput;
  }

  private getPendingEmail(pendingSearchInput: PendingSearchInput | null): string {
    return pendingSearchInput?.filterType === 'email' ? (pendingSearchInput.query || '') : '';
  }

  private getPendingPhone(pendingSearchInput: PendingSearchInput | null): string {
    return pendingSearchInput?.filterType === 'phone' ? (pendingSearchInput.query || '') : '';
  }

  getSignedInUserDetails() {
    return this.signedInUserDetails;
  }

  get getDisclaimerText() {
    return this.translateService.instant('testDrive.privacyPolicyTxt');
  }

  getTranslation(value) {
    return value ? `${this.translateService.instant(`common.${value}`)}` : value;
  }

  onSubmit() {
    this.isSubmitting = true;
    this.valueChanged = true;
    this.onValueChange();
    const payload = { appointmentType: AppointmentType.PARTS, settings: this.settings }
    if (this.editBool) {
      this.partsAppointmentStore.dispatch(new fromActions.EditSalesAppointment(payload));
    }
    else {
      if (this.src === "signal") {
        payload["requestAppSrc"] = AppointmentBookingSource.SIGNAL_CTA;
      }
      this.partsAppointmentStore.dispatch(new fromActions.CreateSalesAppointment(payload));
    }
    this.subscriptions.editDetail = this.partsAppointmentStore.select(fromSelectors.editDetails)
      .subscribe((editDetail) => {
        this.onSubmitting(editDetail);
      });
  }

  onSubmitting(data) {
    if (data) {
      this.isSubmitting = data.isSubmitted;
      if (data.isSubmitted) {
        const urlState = { ...data.appointmentData };
        const navigationExtras: NavigationExtras = {
          queryParams: {
            id: data.appointmentId
          },
          state: urlState
        };
        this.router.navigate(['asp/bdc/parts/confirm'], navigationExtras);
      }
    }
  }

  isValidForm() {
    const vehicle = this.selectVehicleComponent?.step?.getRawValue?.() || {};
    const apptStartDate = this.partsAppointmentForm.get('availability').value?.appointmentStartDate || "";
    const currentDate = DateTime.fromISO(DateTime.now().toString())
      .toFormat(this.dateFormat);
    return this.partsAppointmentForm.valid && this.checkVehicleValues(vehicle) && apptStartDate >= currentDate;
  }

  checkVehicleValues(vehicle: any) {
    if (Object.keys(vehicle).length === 0) {
      return false;
    }

    const hasOrderRefNumber = !!vehicle.orderRefNumber?.toString().trim();
    const hasDealerOrderNumber = !!vehicle.dealerOrderNumber?.toString().trim();
    if (!hasOrderRefNumber && !hasDealerOrderNumber) {
      return false;
    }

    if (vehicle.make) {
      const hasModel = !!vehicle.model;
      const hasYear = !!vehicle.year;
      const hasOtherMake = vehicle.make !== 'Other' || !!vehicle.otherMake;
      return hasModel && hasYear && hasOtherMake;
    }

    if (vehicle.vin) {
      return vehicle.vin.length === 17;
    }

    // Parts flow allows proceeding without vehicle details when none are entered.
    return true;
  }

  onMonthChange($event: any) {
    this.subscriptions.availability = this.partsAppointmentStore.select(fromSelectors.getAvailabilityDetails)
      .pipe(take(1))
      .subscribe(details => {
        const date = $event.toFormat(this.dateFormat);
        this.partsAppointmentStore.dispatch(new fromActions.LoadAvailability(
          {
            selectDateAndSlot: false, date, advisorId: details.advisorId, transport: details.transport, vin: '',
            appointmentType: AppointmentType.PARTS, appointmentId: this.appointmentId ? this.appointmentId : ''
          }));
      });
  }

  backToDashboard() {
    this.router.navigate(['asp/bdc/dashboard']);
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
    this.partsAppointmentStore.dispatch(new fromActions.ResetSalesAppointmentState());
    this.bannerService.update('');
    this.cdr.detach();
  }

}
